/* slick
========================================================= */
export function slick($) {
  const $slider = $('.slider');

  if (!$.fn.slick || !$slider.length) {
    return;
  }

  $slider.slick({
    autoplay: true,
    centerMode: true,
    centerPadding: '12%',
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 4000,
    speed: 400,
    dots: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: '0',
          slidesToShow: 1,
        },
      },
    ],
  });
}
